import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import ApiPath from "./ConstantApi";
import { v4 as uuidv4 } from "uuid";

// Define types for the API
export interface SignInProps {
  email: string;
  password: string;
}

export interface AuthProps {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  image: string;
  password: string;
  email: string;
  accessToken: string;
  refreshToken: string;
}

export interface SignUpProps {
  name: string;
  email: string;
  password: string;
  id?: string;
}

export const getDeviceId = () => {
  let deviceId = localStorage.getItem(
    `${process.env.REACT_APP_STORAGE_KEY}/device-id`
  );
  if (deviceId) {
    return deviceId;
  }
  const newDeviceId = uuidv4();
  localStorage.setItem(
    `${process.env.REACT_APP_STORAGE_KEY}/device-id`,
    newDeviceId
  );
  return newDeviceId;
};

// Create the API slice
export const AuthService = createApi({
  reducerPath: "AuthApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");

      headers.set("x-device-id", getDeviceId());

      return headers;
    },
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation<any, SignInProps>({
      query: (reqBody) => ({
        url: `${ApiPath.signIn}`,
        method: "POST",
        body: reqBody,
      }),
    }),

    signUp: builder.mutation<SignUpProps, SignUpProps>({
      query: (reqBody) => ({
        url: `${ApiPath.signUp}`,
        method: "POST",
        body: reqBody,
      }),
    }),

    checkTokenExpiry: builder.mutation<void, { token: string }>({
      query: (body) => ({
        url: `${ApiPath.checkTokenExpiry}`,
        method: "POST",
        body,
      }),
    }),

    forgotPassword: builder.mutation<void, { email: string; captchaToken?: string | null }>({
      query: (body) => ({
        url: `${ApiPath.forgotPassword}`,
        method: "POST",
        body,
      }),
    }),
    resetPassword: builder.mutation<void, { token: string; password: string }>({
      query: (data) => ({
        url: `${ApiPath.resetPassword}`,
        method: "POST",
        body: { token: data.token, newPassword: data.password },
      }),
    }),

    // take the employeeId and newPassword

    refreshToken: builder.mutation<any, { refreshToken: string }>({
      query: (body) => ({
        url: `${ApiPath.refreshToken}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

// Export hooks for the API
export const {
  useSignInMutation,
  useForgotPasswordMutation,

  useResetPasswordMutation,
  useCheckTokenExpiryMutation,
  useRefreshTokenMutation,
} = AuthService;

// class AuthService {
//     constructor() {}

//     // Mimic API call for Sign In
//     signInApi(username: string, password: string): Promise<{ success: boolean; message: string }> {
//       return new Promise((resolve, reject) => {
//         setTimeout(() => {
//           const storedUser = localStorage.getItem("user");
//           if (!storedUser) {
//             return reject({ success: false, message: "User not found" });
//           }

//           const user = JSON.parse(storedUser);
//           if (user.username === username && user.password === password) {
//             resolve({ success: true, message: "Login successful" });
//           } else {
//             reject({ success: false, message: "Invalid username or password" });
//           }
//         }, 1000); // Simulate API latency
//       });
//     }

//     // Mimic API call for Registration
//     registrationApi(data:any): Promise<{ success: boolean; message: string }> {
//         const {username, email, password}=data;
//       return new Promise((resolve, reject) => {
//         setTimeout(() => {
//           const storedUser = localStorage.getItem("user");
//           if (storedUser) {
//             return reject({ success: false, message: "User already exists" });
//           }

//           const newUser = { username, email, password };
//           localStorage.setItem("user", JSON.stringify(newUser));
//           resolve({ success: true, message: "Registration successful" });
//         }, 1000); // Simulate API latency
//       });
//     }
//   }

//   export default new AuthService();
